export default "__VITE_ASSET__Cd1U2654__"